export  const GOOGLE_ICON = require('./images/Glogo2.png');
export  const FACEBOOK_ICON = require('./images/Flogo2.png');
